import TMForm from "./components/TMForm";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#a95216',
    },
    secondary: {
      main: '#a95216',
    },
  },
});

function App() {
  return (
      <ThemeProvider theme={theme}>
      <TMForm/>
      </ThemeProvider>
  );
}

export default App;
